import { defineComponent } from "@vue/composition-api";
import { CreateElement, RenderContext, VNode } from "vue";

type Props = {
  text: string;
};

export default defineComponent({
  name: "BaseTitle",
  functional: true,
  props: {
    text: { type: String },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    return h(
      "h1",
      {
        staticClass: "base-title",
        class: [...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]), ctx.data.staticClass],
      },
      [(ctx.scopedSlots.default && ctx.scopedSlots.default({})) || ctx.props.text]
    );
  },
});
